import React from "react";
import styles from "./DialogFooter.module.css";

export interface DialogFooterProps {
  children: React.ReactNode;
  align?: "left" | "center" | "right";
  className?: string;
}

export const DialogFooter: React.FC<DialogFooterProps> = ({
  children,
  align = "right",
  className,
}) => {
  return (
    <div className={`${styles.Footer} ${styles[align]} ${className || ""}`}>
      {children}
    </div>
  );
};
